import './style.scss'
import SunEditor from 'suneditor-react'
import 'suneditor/dist/css/suneditor.min.css'
import { useRef, useEffect } from 'react'

const DEFAULT_OPTIONS = {
  buttonList: [
    ['fontSize'],
    ['bold', 'italic', 'underline', 'strike'],
    ['fontColor', 'hiliteColor'],
    ['align', 'list'],
    ['link'],
    ['removeFormat'],
  ],
  pasteTagsBlacklist: 'span',
  defaultTag: 'p',
  linkTargetNewWindow: true,
}

export const Editor = (props) => {
  const { value, onChange, setOptions } = props || {}
  const onChangeRef = useRef(onChange)
  useEffect(() => { onChangeRef.current = onChange }, [onChange])

  const editorInstanceRef = useRef(null)
  const seededRef = useRef(false)

  useEffect(() => {
    if (value && !seededRef.current && editorInstanceRef.current) {
      editorInstanceRef.current.setContents(value)
      seededRef.current = true
    }
  }, [value])

  const handleKeyDown = (e) => {
    if ((e.metaKey || e.ctrlKey) && e.key === 'k') {
      e.preventDefault()
      const core = editorInstanceRef.current?.core
      if (core) {
        core.callPlugin('link', () => {
          core.plugins.link.open.call(core, null)
        }, null)
      }
    }
  }

  return (
    <SunEditor
      {...props}
      setOptions={setOptions || DEFAULT_OPTIONS}
      defaultValue={value}
      getSunEditorInstance={(editor) => {
        editorInstanceRef.current = editor
        // Remove the dropdown caret from the fontSize button
        setTimeout(() => {
          const caret = editor.core.context.element.toolbar.querySelector('.se-btn-tool-size svg')
          if (caret) caret.remove()
        }, 0)
      }}
      onChange={(content) => onChangeRef.current?.(content)}
      onKeyDown={handleKeyDown}
    />
  )
}
